// extracted by mini-css-extract-plugin
export default {"input":"FileInput_input__Maa2L","message":"FileInput_message__Y6MC3"};